export const getBaseUrl = (slug: string): string => {
  const scheme = process.env.NEXT_PUBLIC_TACTIC_SCHEME;
  const domain = process.env.NEXT_PUBLIC_TACTIC_DOMAIN;
  const port = process.env.NEXT_PUBLIC_TACTIC_PORT ? `:${process.env.NEXT_PUBLIC_TACTIC_PORT}` : '';
  return `${scheme}://${slug}.${domain}${port}`;
};
